<template>
  <div class="wrapper">
    <div>
      <router-link to="../map_reports">マップレポート一覧</router-link>
      <span> > マップレポート</span>
    </div>
    <v-card v-if="!isError" color="transparent" style="height: 85%" flat>
      <v-card-text>
        レポート名：
        <strong>{{ mapReport.name }}</strong>
        <span class="padding">案件名：</span>
        <strong>{{ mapReport.insertionOrderName }}</strong>
        <span class="padding">抽出期間：</span>
        <strong>{{ mapReport.extractionPeriod }}</strong>
      </v-card-text>
      <div class="iframe">
        <MglMap
          v-if="isMapbox"
          :accessToken="accessToken"
          :mapStyle="mapReport.url"
          :keyboard="false"
        />
        <MapViewerMapReport v-else-if="isMapViewer" :url="mapReport.url" />
        <NotFoundMapReport v-else-if="Object.values(mapReport).length > 0" />
      </div>
      <div class="usageGuide">
        <span>クリック地点</span>
        <img :src="imgUsageGuideClick" height="20" width="20" />
        <img :src="imgUsageGuideImp" height="25" width="150" />
      </div>
    </v-card>
    <v-card v-if="isError">
      <NoPermission />
    </v-card>
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import { MapReportRepository } from '@/models/MapReport/MapReportRepository'
import { MglMap } from 'vue-mapbox'
import usageGuideImp from '@/assets/images/advertiser/map-report-usage-guide-imp.png'
import usageGuideClick from '@/assets/images/advertiser/map-report-usage-guide-click.png'
import NoPermission from '@/pages/NoPermission'
import MapViewerMapReport from '@/components/Advertiser/Report/MapReport/MapViewerMapReport.vue'
import NotFoundMapReport from '@/components/Advertiser/Report/MapReport/NotFoundMapReport.vue'

const ViewerType = {
  Mapbox: 'mapbox',
  MapViewer: 'mapViewer',
}

export default {
  name: 'MapReport',
  components: {
    MapViewerMapReport,
    NotFoundMapReport,
    NoPermission,
    MglMap,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      mapReport: {},
      imgUsageGuideImp: usageGuideImp,
      imgUsageGuideClick: usageGuideClick,
      isError: false,
      accessToken:
        'pk.eyJ1Ijoid25vZ3VjaGkiLCJhIjoiY2lqY2c2dmxuMDAxZHUxamJwMGl3ZnV5ciJ9.WBilN5epB7RdyO-JbUQd2A',
    }
  },
  computed: {
    isMapbox() {
      return this.viewerType === ViewerType.Mapbox
    },
    isMapViewer() {
      return this.viewerType === ViewerType.MapViewer
    },
    viewerType() {
      const mapboxUrlPattern = /^mapbox:\/\/styles\/wnoguchi\/.+/g
      const mapViewerUrlPattern = /^https?:\/\/map-viewer.+/g

      if (mapViewerUrlPattern.test(this.mapReport.url)) {
        return ViewerType.MapViewer
      } else if (mapboxUrlPattern.test(this.mapReport.url)) {
        return ViewerType.Mapbox
      } else {
        return null
      }
    },
  },
  created() {
    this.getMapReport()
  },
  methods: {
    async getMapReport() {
      const mapReport = await MapReportRepository.findById(
        this.$route.params.mapReportId,
        this.$route.params.advertiserId,
      )
      if (mapReport) {
        this.mapReport = mapReport
      } else {
        this.isError = true
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.iframe {
  height: 100%;
}
.padding {
  margin-left: 20px;
}
.usageGuide {
  text-align: right;
  white-space: nowrap;
}
</style>
